import { Product } from '../../../../../../Hub/TrainingHub/models';
import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export interface UserProductAccountProduct {
  id: number;
  accountId: number;
  sourceAgreementItemId: number;
  sku: string;
  quantity: number;
  quantityAssigned: number;
  quantityRedeemed: number;
  createdDate: string;
  modifiedDate: string;
  quantityNotAssigned: number;
  quantityNotRedeemed: number;
}

export interface UserProduct {
  id: number;
  productName: string;
  agreementName: string;
  agreementId: string;
  accountProductId: number;
  zones:
    | {
        regionTypeId: number;
        regionType: {
          id: number;
          name: string;
        };
        restrictionTypeId: number;
        restrictionType: {
          id: number;
          name: string;
        };
        value: string;
      }[]
    | string[];
  assignedDate: string;
  enrollmentStatus: string;
  enrollmentProviderIncrementId: string;
  enrollmentDate: string | null;
  eventDate: string | null;
  isSelfServiceProduct: boolean;
  userId: number;
  product: UserProductAccountProduct;
  quantityAssigned: number;
  quantityRedeemed: number;
  modifiedDate: string;
  createdDate: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserCurrentProducts: builder.query<UserProduct[], { userId: string }>({
      query: ({ userId }) => `/v4/users/${userId}/assignments`,
      providesTags: ['User', 'Product'],
    }),
    getDiagnosticsByProduct: builder.query<
      Product,
      {
        accountId: string;
        personId: number;
        sku: string;
        userId: string;
      }
    >({
      query: ({ accountId, personId, sku, userId }) =>
        `/v4/verify/account/${accountId}?personId=${personId}&userId=${userId}&sku=${sku}`,
      providesTags: ['Diagnostics'],
    }),
    removeEnrolledProduct: builder.mutation<
      any,
      {
        userId: number;
        modifiedByUser: { id: number; name: string };
        accountProductId: number;
        agreementId?: string;
      }
    >({
      query: ({ userId, modifiedByUser, accountProductId, agreementId }) => ({
        url: `/v4/users/${userId}/assignments/remove`,
        method: 'DELETE',
        body: {
          userAssignmentIds: [accountProductId],
          modifiedByPersonId: modifiedByUser.id,
          modifiedByPersonFullName: modifiedByUser.name,
          agreementId,
        },
      }),
      invalidatesTags: ['User'],
    }),
    unEnrolledProduct: builder.mutation<
      any,
      { userId: number; userAssignmentId: number }
    >({
      query: ({ userId, userAssignmentId }) => ({
        url: `/v4/users/${userId}/assignments/unenroll`,
        method: 'PUT',
        body: {
          userId,
          userAssignmentId,
        },
      }),
      invalidatesTags: ['User'],
    }),
    reAssignProduct: builder.mutation<
      any,
      {
        userId: number;
        accountProductIdToRemove: number;
        accountProductIdToAssign: number;
        modifiedByUser: { id: number; name: string };
      }
    >({
      query: ({
        userId,
        accountProductIdToAssign,
        accountProductIdToRemove,
        modifiedByUser,
      }) => ({
        url: `/v4/users/${userId}/assignments/reassign`,
        method: 'PUT',
        body: {
          accountProductIdToRemove,
          modifiedByPersonId: modifiedByUser.id,
          modifiedByPersonFullName: modifiedByUser.name,
          userId,
          accountProductIdToAssign,
          reassignDate: new Date(),
        },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetDiagnosticsByProductQuery,
  useGetUserCurrentProductsQuery,
  useRemoveEnrolledProductMutation,
  useUnEnrolledProductMutation,
  useReAssignProductMutation,
} = apiSlice;
